module.exports = {"slides":[{"children":[{"element":"Heading","children":"Introducción a Polymer"},{"element":"Paragraph","children":"TODO: Presentation to be migrated"}]}]}


//////////////////
// WEBPACK FOOTER
// ./pages/talks/introduccion-polymer/introduccion-polymer.json
// module id = ./pages/talks/introduccion-polymer/introduccion-polymer.json
// module chunks = 9